import { EpgChannel } from './EpgChannel';
import { EpgChannelGenre } from "./EpgChannelGenre";
import List from "./lib/List";

export interface IChannelGroup {
  id: number;
  title: string;
  channels: List<EpgChannel['id']>;
  isCurrentProgramLoaded: boolean;
}

const _genre_ = Symbol('genre');

export class ChannelGroup implements IChannelGroup {
  public channels = new List<EpgChannel['id']>();

  private [_genre_]: EpgChannelGenre;
  /**
   * Indicates whether the current program is loaded for this group.
   * @deprecated It seems that this property is not used anywhere.
   * @private
   */
  private _isCurrentProgramLoaded: boolean = false;

  constructor(genre: EpgChannelGenre) {
    this[_genre_] = genre;
  }

  public get id() {
    return this[_genre_].id;
  }

  public get title() {
    return this[_genre_].title;
  }

  get isCurrentProgramLoaded(): boolean {
    return this._isCurrentProgramLoaded;
  }

  set isCurrentProgramLoaded(value: boolean) {
    this._isCurrentProgramLoaded = value;
  }
}
